// build params from object

export default class BuildParamsHelpers {
  static buildGetParams(obj) {
    let result = "";
    for (var key in obj) {
        if (result !== "") {
            result += "&";
        }
        result += key + "=" + obj[key];
    }

    return result
  }
}
